import React, { useEffect, useState } from 'react'
import { Alert, Modal, Select, Typography } from 'antd'

const { Text } = Typography
const { Option } = Select

// 2026-11-03 coder(whx): 与 VibeAppManagement 的取值口径保持一致，用户ID 兼容多种字段命名
const defaultGetUserValue = item => item.userId || item.USER_ID || item.user_id || item.id || item.value

const defaultGetUserLabel = item => {
    const name = item.userNick || item.USER_NICK || item.user_nick || item.nick || item.label || ''
    const account = item.userName || item.USER_NAME || item.user_name || item.name || item.email || defaultGetUserValue(item)
    return name && account && name !== account ? `${name}（${account}）` : (name || account || '-')
}

const formatValueText = value => (value && String(value).trim()) || '-'

/**
 * 项目用户字段弹窗（登记人 / 上传人，单个与批量共用）。
 *
 * 登记人对应 t_vibe_project.owner_user_id（单人）；上传人对应 t_vibe_project.data_owner（多人自由文本）。
 * 提交后原值会被整体覆盖，因此由调用方传入对应的风险提示 alertMessage。
 */
const VibeProjectUserModal = ({
    visible,
    title = '修改用户',
    alertMessage,
    currentValueLabel = '当前值',
    projects = [],
    users = [],
    submitting = false,
    onCancel,
    onSubmit,
    getUserLabel = defaultGetUserLabel,
    getUserValue = defaultGetUserValue,
}) => {
    const [selectedUserId, setSelectedUserId] = useState(undefined)

    // 每次打开重新选择目标用户，避免把上一次的目标用户带进来误提交
    useEffect(() => {
        if (visible) {
            setSelectedUserId(undefined)
        }
    }, [visible])

    const projectList = Array.isArray(projects) ? projects : []
    const userList = Array.isArray(users) ? users : []
    const submitDisabled = !selectedUserId || projectList.length === 0

    const submit = () => {
        if (submitting || submitDisabled) return
        if (onSubmit) {
            onSubmit({
                projectIds: projectList.map(item => item.id),
                ownerUserId: selectedUserId,
            })
        }
    }

    return (
        <Modal
            title={title}
            visible={visible}
            width={640}
            okText="确定"
            cancelText="取消"
            confirmLoading={submitting}
            okButtonProps={{ disabled: submitDisabled }}
            onOk={submit}
            onCancel={onCancel}
            destroyOnClose
        >
            <Alert
                type="warning"
                showIcon
                style={{ marginBottom: 12 }}
                message={alertMessage}
            />
            <div style={{ marginBottom: 16 }}>
                <Text strong>将修改的数据源（{projectList.length} 个）</Text>
                <div style={{
                    marginTop: 8,
                    maxHeight: 200,
                    overflow: 'auto',
                    background: '#fafafa',
                    border: '1px solid #f0f0f0',
                    borderRadius: 4,
                    padding: '8px 12px',
                }}
                >
                    {projectList.length ? projectList.map(project => (
                        <div
                            key={project.id}
                            style={{ display: 'flex', justifyContent: 'space-between', gap: 12, padding: '2px 0' }}
                        >
                            <Text>{project.projectName || project.id}</Text>
                            <Text type="secondary">{currentValueLabel}：{formatValueText(project.currentValue)}</Text>
                        </div>
                    )) : <Text type="secondary">请先选择要修改的数据源</Text>}
                </div>
            </div>
            <div>
                <div style={{ marginBottom: 8 }}><Text strong>目标用户</Text></div>
                <Select
                    showSearch
                    optionFilterProp="children"
                    placeholder="选择目标用户"
                    aria-label="目标用户"
                    style={{ width: '100%' }}
                    value={selectedUserId}
                    onChange={value => setSelectedUserId(value)}
                >
                    {userList.map(item => (
                        <Option key={getUserValue(item)} value={getUserValue(item)}>
                            {getUserLabel(item)}
                        </Option>
                    ))}
                </Select>
            </div>
        </Modal>
    )
}

export default VibeProjectUserModal
